import { Component, Input, OnInit } from '@angular/core';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';

@Component({
  selector: 'app-tasks-properties',
  templateUrl: './tasks-properties.component.html',
  styleUrls: ['./tasks-properties.component.css']
})
export class TasksPropertiesComponent implements OnInit {

  groupHeaders = ['Error', 'Negocio', 'Cliente', 'Tarea'];
  @Input() taskDetails: TaskDetailsObject;

  constructor() { }

  ngOnInit() {
  }

}
